import Api from "@/services/service-v2";

export const onboardNewCustomer = (payload) =>
  Api().$http.post(`/order/api/v2/order/onboarding-create-order`, payload);

export const updateCustomer = (payload) =>
  Api().$http.post(
    `cap/users/customer/update-user-profile/${payload.id}`,
    payload.data
  );

export const fetchOnboardCustomerList = () =>
  Api().$http.get(`/cap/users/customer/list?limit=5000`);

export const customerDetails = (id) =>
  Api().$http.get(`/cap/users/customer/internal/detail/${id}`);
export const terminateCustomer = (payload) =>
  Api().$http.post(`/servicerequest/ticket/create?type=termination`, payload);
export const requestList = (id) =>
  Api().$http.get(
    `/order/api/v1/get/listbycustomer/${id}?limit=20&type=SERVICE&tenant=66f1000a05fe0c77e56a7624`
  );
export const requestList2 = (id) =>
  Api().$http.get(
    `/order/api/v1/get/listbycustomer/${id}?limit=20&type=REALESTATE&tenant=66f1000a05fe0c77e56a7624`
  );
export const fetchSubCategories = (id) =>
  Api().$http.get(`/catalog/api/catalog/read/catalog?parent=${id}`);
export const booking = (payload) =>
  Api().$http.post(`/catalog/api/item/homecare-items/filter`, payload);
export const bookingDetails = (payload) =>
  Api().$http.post(`/catalog/api/item/items-by-provider/filter`, payload);
export const agentDetails = (payload) =>
  Api().$http.post(
    `/catalog/api/catalog/read/catalog/item/by?page=1&limit=count`,
    payload
  );
export const checkout = (payload) =>
  Api().$http.post(`/checkout/appointment/book`, payload);
